var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJordan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30437 7.82611H23.2536C21.5581 3.2565 17.1596 0 12 0C8.68625 0 5.68657 1.34339 3.51514 3.51511L7.30437 7.82611Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30437 16.1739H23.2536C21.5581 20.7435 17.1596 24 12 24C8.68625 24 5.68657 22.6566 3.51514 20.4849L7.30437 16.1739Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.51468C-1.17157 8.20096 -1.17157 15.799 3.51471 20.4853C5.45126 18.5488 7.31374 16.6863 12 12L3.51471 3.51468Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76274 9.39133L5.42129 10.7685L6.90858 10.4247L6.24249 11.7982L7.43851 12.7467L5.94943 13.0823L5.95355 14.6087L4.76274 13.6537L3.57188 14.6087L3.57605 13.0823L2.08698 12.7467L3.28294 11.7982L2.61694 10.4247L4.10415 10.7685L4.76274 9.39133Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJordan);
export default __webpack_public_path__ + "static/media/jordan.b4839adf48f1ff92da00da272c612b64.svg";
export { ForwardRef as ReactComponent };